import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, Divider, Text, Title } from "@mantine/core";

export function AboutSection({ title = "About Me", description }) {
  return (
    <Card shadow="none" withBorder={false} radius="0" aria-labelledby="about-heading" pt="md">
      <Title order={4} id="about-heading" mb="sm">
        {title}
      </Title>
      <Text lh={1.6}>
        {description}
      </Text>
        <Divider
          my="lg"
          styles={{
            root: {
              backgroundColor: "#e5e7eb",
              opacity: 0.4,
            },
          }}/>
      </Card>
    );
}
